var exports = {
  "Nr": "PricingCard.module__card___WDRHUW",
  "OW": "PricingCard.module__cardDefault___WDRHUW" + " " + "PricingCard.module__card___WDRHUW",
  "WI": "PricingCard.module__cardPopular___WDRHUW" + " " + "PricingCard.module__card___WDRHUW",
  "uX": "PricingCard.module__badgeSpace___WDRHUW",
  "qS": "PricingCard.module__badge___WDRHUW",
  "Ys": "PricingCard.module__badgeOnBrand___WDRHUW",
  "HH": "PricingCard.module__badgePlaceholder___WDRHUW",
  "zH": "PricingCard.module__popularBadge___WDRHUW",
  "B_": "PricingCard.module__popularBadgeSpace___WDRHUW",
  "r9": "PricingCard.module__disabled___WDRHUW",
  "L5": "PricingCard.module__selectButton___WDRHUW",
  "_C": "PricingCard.module__soldOutBadge___WDRHUW",
  "hQ": "PricingCard.module__contentContainer___WDRHUW",
  "JJ": "PricingCard.module__cardTitle___WDRHUW",
  "UZ": "PricingCard.module__cardTitleDefault___WDRHUW" + " " + "PricingCard.module__cardTitle___WDRHUW",
  "_": "PricingCard.module__cardTitlePopular___WDRHUW" + " " + "PricingCard.module__cardTitle___WDRHUW",
  "CA": "PricingCard.module__cardPrice___WDRHUW",
  "$V": "PricingCard.module__cardPriceDefault___WDRHUW" + " " + "PricingCard.module__cardPrice___WDRHUW",
  "pW": "PricingCard.module__cardPricePopular___WDRHUW" + " " + "PricingCard.module__cardPrice___WDRHUW",
  "ce": "PricingCard.module__cardPeriod___WDRHUW",
  "Lo": "PricingCard.module__cardPeriodDefault___WDRHUW" + " " + "PricingCard.module__cardPeriod___WDRHUW",
  "xP": "PricingCard.module__cardPeriodPopular___WDRHUW" + " " + "PricingCard.module__cardPeriod___WDRHUW",
  "pC": "PricingCard.module__popularBadgeLabel___WDRHUW",
  "Jb": "PricingCard.module__originalPrice___WDRHUW",
  "AZ": "PricingCard.module__originalPriceDefault___WDRHUW" + " " + "PricingCard.module__originalPrice___WDRHUW",
  "WK": "PricingCard.module__originalPricePopular___WDRHUW" + " " + "PricingCard.module__originalPrice___WDRHUW",
  "sM": "PricingCard.module__srOnly___WDRHUW",
  "qr": "PricingCard.module__footer___WDRHUW",
  "pv": "PricingCard.module__footerDefault___WDRHUW" + " " + "PricingCard.module__footer___WDRHUW",
  "VN": "PricingCard.module__footerPopular___WDRHUW" + " " + "PricingCard.module__footer___WDRHUW",
};

module.exports = exports;
